

import React from "react";
// import {Link} from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
// import {useTranslation} from "react-i18next";
import "./FeaturesListNav.css";

let featursList = [
  // {name: "Accounting Integrations", to: "/features/accounting-integration"},
  { name: "Amenity Bookings", to: "/amenity-bookings" },
  { name: "Announcements", to: "/announcements" },
  { name: "Bulletin Board", to: "/bulletin-board" },
  //{name: "Complaints", to: "/complaints"},
  //{name: "e-Consent ", to: "/e-consent"},
  { name: "Events Calendar", to: "/events-calendar" },
  { name: "Document Drive", to: "/document-drive" },
  { name: "Maintenance Requests", to: "/maintenance-requests" },
  // {name: "Online Payments", to: "/online-payments"},
  { name: "Property Accounting", to: "/property-accounting" },
  { name: "Resident Directory", to: "/resident-directory" },
  // {name: "Package Management", to: "/package-management"},
  // {name: "Portfolio Management", to: "/portfolio-management"},
  // {name: "Resident Hub", to: "/resident-hub"},
  { name: "Vendor Management", to: "/vendor-management" },
  { name: "Violations Tracking", to: "/violations-tracking" },
  { name: "Visitor Management", to: "/visitor-management" },
  { name: "Visitor Parking Permit", to: "/visitor-parking-permit" },
];

const FeaturesListNav = () => {
  // const {t} = useTranslation();

  // featursList = featursList.map(v => {
  //   return {name: v, to: "/features/amenity-bookings"};
  // });

  return (
    <div>
      <Container>
        <Row className="">
          {/* <Col sm={4} md={6} lg={6}> */}
          <Col>
            <ul
              className="text-dark cus-ul"
              style={{
                // lineHeight: "20px",
                cursor: "pointer",
                listStyleType: "none",
              }}
            >
              {featursList.map((v, i) => (
                <li key={i + "321"}>
                  <a
                    href={v.to}
                    className="cool-link text-dark"
                    onClick={() => (window.location.href = v.to)}
                  >
                    <span className="h3"></span>{" "}
                    {/* {t("features.amenity_bookings")} */}
                    {v.name}
                  </a>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FeaturesListNav;
